import { Container } from '@mui/material';
import { HeaderWrapper, HeaderTitle, HeaderSubtitle } from './styles';

const PolicyHeader = ({ title, subtitle }) => {
  return (
    <HeaderWrapper>
      <Container maxWidth="md">
        {/* The policy name is the page's <h1>; variant keeps the h3 styling. */}
        <HeaderTitle variant="h3" component="h1">
          {title}
        </HeaderTitle>
        {subtitle && <HeaderSubtitle variant="h6">{subtitle}</HeaderSubtitle>}
      </Container>
    </HeaderWrapper>
  );
};

export default PolicyHeader;
